/* App.js 
       Instancia Principal para referenciarla en index.html
       Desarrollado por JC Yocop       
======================================================================================================== */    
// import firebase     from 'firebase';

export default {
  
  name: 'app',
  data(){
      return{
      }
  },
  methods:{
  }, // methods
} // export



// WEBPACK FOOTER //
// ./src/App.js